'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _glamor = require('glamor');

var _reactPlayer = require('react-player');

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _components = require('@bodhi-project/components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstract stuff

// import moment from 'moment';

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components
// eslint-disable-line import/no-extraneous-dependencies
// import PropTypes from 'prop-types';
var Fragment = _react2.default.Fragment;

/**
// if (element.type === 'linkReference') {
//   url = linkElement.children[0].value;
  
// } else {
//   url = linkElement.url; // eslint-disable-line prefer-destructuring
//   text = linkElement.children[0].value;
//   if (url.includes('vimeo') || url.includes('youtube')) {
//     frag = (
//       <div style={{ textAlign: 'center' }}>
//         <ReactPlayer url={url} style={{ marginBottom: 20, marginRight: 'auto', marginLeft: 'auto' }} />
//       </div>
//     );
//   } else {
//     if (url.includes('http')) { // It it's an out-bound link
//       frag = <OutLink to={url}>{text}</OutLink>
//     } else {
//       if (!_.isUndefined(options.localLink)) {
//         const LocalLink = options.localLink;
//         frag = <LocalLink to={url}>{text}</LocalLink>
//       } else {
//         frag = <a href={url}>{text}</a>
//       }
//     }
//   }
// }
*/

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Locals
// ------------------------------------------------------------------------------

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Styles
// ------------------------------------------------------------------------------
// ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Imports
// ------------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries

var video = (0, _glamor.css)({
  marginBottom: 20,
  '@media(max-width: 768px)': {
    height: 'auto !important',
    width: '100% !important'
  }
});
var videoClass = video.toString();

// ------------------------------------------------------------------------------
// -------------------------------------------------------------------- Component
// ------------------------------------------------------------------------------
/**
  * linkParser
  */
var linkParser = function linkParser(element) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var frag = _react2.default.createElement(Fragment, null);

  if (element.type === 'link') {
    var url = element.url;
    var value = element.children[0].value;


    if ((url.includes('vimeo') || url.includes('youtube')) && value === 'embed') {
      frag = _react2.default.createElement(
        'div',
        { style: { textAlign: 'center' } },
        _react2.default.createElement(_reactPlayer2.default, { url: url, className: videoClass })
      );
    } else {
      if (url.includes('http')) {
        // It it's an out-bound link
        frag = _react2.default.createElement(
          _components.OutLink,
          { to: url },
          value
        );
      } else {
        if (!_lodash2.default.isUndefined(options.localLink)) {
          var LocalLink = options.localLink;
          frag = _react2.default.createElement(
            LocalLink,
            { to: url },
            value
          );
        } else {
          frag = _react2.default.createElement(
            'a',
            { href: url },
            value
          );
        }
      }
    }
  }

  return frag;
};

linkParser.propTypes = process.env.NODE_ENV !== "production" ? {} : {};

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Export
// ------------------------------------------------------------------------------
exports.default = linkParser;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@bodhi-project/markdown-to-react/lib/parsers/linkParser.js
// module id = 439
// module chunks = 168707334958949